import { render, staticRenderFns } from "./SafeTemplete.vue?vue&type=template&id=ca6b5838"
import script from "./SafeTemplete.vue?vue&type=script&lang=js"
export * from "./SafeTemplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports